module.exports = __webpack_public_path__ + "static/img/background1.1ed1165a.png";